import { Component, OnInit, inject } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DipendentiService } from '../../../shared/services/dipendenti.service';
import {
  DxPopupComponent,
  DxDataGridComponent,
  DxTemplateDirective,
  DxLoadPanelComponent,
} from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import * as FileSaver from 'file-saver';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import saveAs from 'file-saver';
import { AllegatiMovService } from 'src/app/shared/services/allegati-mov.service';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { confirm } from 'devextreme/ui/dialog';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import {
  MovimentoArticolo,
  MovimentoArticoloModel,
} from 'src/app/models/movimento-articolo';
import { Dipendente } from 'src/app/models/dipendente';
import { Articoli } from 'src/app/models/articoli';
import { AllegatiMovimenti } from 'src/app/models/allegati-movimenti';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import notify from 'devextreme/ui/notify';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { BtnNuovaConsegnaComponent } from 'src/app/shared/components/dipendenti/btn-nuova-consegna/btn-nuova-consegna.component';

@Component({
  selector: 'app-movimenti-articoli',
  templateUrl: './movimenti-articoli.component.html',
  imports: [
    DxPopupComponent,
    DxDataGridComponent,
    DxTemplateDirective,
    DxoLookupComponent,
    DxiColumnComponent,
    DxoExportComponent,
    DxoEditingComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoTextsComponent,
    BtnNuovaConsegnaComponent,
    DxLoadPanelComponent
  ],
  standalone: true,
})
export class MovimentiArticoliComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private movS = inject(MovimentoArticoliService);
  private dipS = inject(DipendentiService);
  private articoliS = inject(ArticoliService);
  private allS = inject(AllegatiMovService);
  private nS = inject(NavigatorService);
  private sanitizer = inject(DomSanitizer);
  private route = inject(ActivatedRoute);
  private artMatS = inject(ArticoliMatricolaService);

  dataSource: any;
  articoliList: Observable<MovimentoArticolo[]>;
  collapsed = false;
  listDip: Dipendente[] = [];
  listArticoli: Articoli[] = [];
  listMovArticoli: MovimentoArticolo[] = [];
  listArticoliMatricola: any;
  allegatiList: AllegatiMovimenti[] = [];
  allegatiMovDataSourceStorage: any;
  popupImageVisible = false;
  currentImage: SafeResourceUrl;
  firmati = true;

  gestMatricole: boolean;
  loadPanelVisible = false;

  constructor() {
    super();

    this.gestMatricole = this.isModVisible('Matricole');

    this.route.paramMap.subscribe((params) => {
      this.firmati = params.get('firmati') == 'true';
      this.allegatiMovDataSourceStorage = [];
      this.dipS.listTemp().subscribe((dipendenti) => {
        this.listDip = dipendenti;
      });
      this.allS.list().subscribe((allegati) => {
        this.allegatiList = allegati;
        console.log(allegati);
      });
      this.articoliS.listTemp().subscribe((articoli) => {
        this.listArticoli = articoli;
      });
      this.movS.list().subscribe((movArticoli) => {
        this.listMovArticoli = movArticoli;
        this.loadDataSource();
      });
    });
  }

  reloadData() {
    this.movS.list().subscribe((dati) => {
      this.listMovArticoli = dati;
      this.loadDataSource();
    });
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.listMovArticoli
          .filter((m) => m.firmato == this.firmati)
          .sort((a, b) => (a.data < b.data ? 1 : -1));
      },
      insert: (values) => {
        const model: MovimentoArticoloModel = {
          idDipendente: values.idDipendente,
          data: values.data,
          dettagli: values.dettagli,
          firmato: values.firmato,
          allegato: values.allegato,
          allegatoByte: values.allegatoByte,
          progr: values.progr,
          listDettaglio: [],
          nominativoDipendente: '',
          inviaMail: false,
        };
        return firstValueFrom(this.movS.insert(model))
          .then(() => {
            return values;
          })
          .catch(() => {
            throw 'Insertion failed';
          });
      },
      remove: (values) => {
        return (
          firstValueFrom(this.movS.remove(values))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              //throw 'Deletion failed'
              console.log(error.error.title);
              throw error.error.title;
            })
        );
      },
      update: (key, values) => {
        return firstValueFrom(this.movS.update(key, values)).catch(() => {
          throw 'Update failed';
        });
      },
    });
  }

  onRowRemoved() {
    this.reloadData();
  }

  scaricaFile(mov: MovimentoArticolo) {
    this.loadPanelVisible = true;
    this.movS.scarica(mov.id).subscribe({
        next: (res) => {
          this.loadPanelVisible = false;
          FileSaver.saveAs(res, mov.allegato);
        },
         error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore download file', 'warning');
          }
        },
    });
  }

  scaricaFileAllegato(allegato: AllegatiMovimenti) {
    this.loadPanelVisible = true;
    this.allS.scarica(allegato.id).subscribe({
        next: (res) => {
          this.loadPanelVisible = false;
          FileSaver.saveAs(res, allegato.nomeFile);
        },
         error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore download file allegato', 'warning');
          }
        },
    });
  }

  onExporting(e) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('consegnati');
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          'elencoArticoliConsegnati.xlsx',
        );
      });
    });
    e.cancel = true;
  }

  getAllegati(idMovimento) {
    let item = this.allegatiMovDataSourceStorage.find(
      (i) => i.idMovimento === idMovimento,
    );
    if (!item) {
      item = {
        idMovimento: idMovimento,
        dataSourceInstance: new DataSource({
          store: new ArrayStore({
            data: this.allegatiList,
            key: 'id',
          }),
          filter: ['idMovimento', '=', idMovimento],
        }),
      };
      this.allegatiMovDataSourceStorage.push(item);
    }
    return item.dataSourceInstance;
  }
  eliminaFile(allegato: AllegatiMovimenti) {
    const result = confirm("<i>Vuoi eliminare l'allegato?</i>", 'Conferma');
    result.then((dialogResult) => {
      if (dialogResult) {
        this.allS.delete(allegato.id).subscribe(() => {
          console.log('Allegato eliminato');
          this.allS.list().subscribe((dati) => {
            this.allegatiList = dati;
            console.log(dati);
            this.allegatiMovDataSourceStorage = [];
          });
        });
      }
    });
  }

  visualizzaFile(allegato: AllegatiMovimenti) {
    this.allS.scarica(allegato.id).subscribe((res) => {
      const url = window.URL.createObjectURL(res);
      window.open(url);
    });
  }

  visualizzaImmagine(allegato: AllegatiMovimenti) {
    this.allS.getImmagine(allegato.id).subscribe((res) => {
      this.currentImage = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image;base64,' + res,
      );
      this.popupImageVisible = true;
    });
  }

  firmaDocumento(mov: MovimentoArticolo) {
    this.nS.goToDocMovimento(mov.progr);
  }

  onInitNewRow() {
    this.nS.goToNewMovimento();
    return false;
  }

  goToAllegaMov(idMov: number) {
    this.nS.goToAllegaMov(idMov);
  }

  endsWith(str, suffix) {
    if (str == undefined) {
      return false;
    }
    return (
      str
        .toUpperCase()
        .indexOf(suffix.toUpperCase(), str.length - suffix.length) !== -1
    );
  }
  ngOnInit() {
    this.loadLookups();
  }

  loadLookups() {
    if (this.gestMatricole) {
      this.artMatS.list().subscribe({
        next: (res) => {
          this.listArticoliMatricola = {
            store: {
              type: 'array',
              data: res,
              key: 'id',
            },
            pageSize: 10,
            paginate: true,
          };
        },
        error: (error) => {
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore caricamento articoli matricola ', 'warning');
          }
        },
      });
    }
  }

  displayArticolo(articolo: Articoli){
    if(!articolo){
      return '';
    }
    return articolo.codice + ' - ' + articolo.descrizione;
  }
}
